export default {
  title: "Anagrafiche",
  icon: "mdi-domain",
  groups: [
    "Amministrazione",
    "Schedulazione",
    "Magazzino",
    "Milkrun",
  ],
  submenu: [{ title: "Clienti e fornitori", route: { name: "Anagrafiche" } }],
};
